import styles from './Checkbox.module.scss'
import { DefaultCheckedIcon, DefaultIcon } from './icons'

interface CheckboxProps {
  checked: boolean
  className?: string
  decorative?: boolean
  indeterminate?: boolean
  onClick?: (checked: boolean) => void
}

const Checkbox = ({
  checked,
  className,
  decorative = false,
  indeterminate = false,
  onClick,
}: CheckboxProps) => {
  const content = indeterminate ? <DefaultIcon /> : checked ? <DefaultCheckedIcon /> : null
  const ariaChecked = indeterminate ? 'mixed' : checked

  if (decorative) {
    return (
      <span
        aria-checked={ariaChecked}
        aria-hidden
        className={[styles.checkbox, className].join(' ')}
      >
        {content}
      </span>
    )
  }

  return (
    <button
      aria-checked={ariaChecked}
      className={[styles.checkbox, className].join(' ')}
      onClick={onClick ? () => onClick(checked) : undefined}
      role="checkbox"
      type="button"
    >
      {content}
    </button>
  )
}

export default Checkbox
